/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Online_Price_TitleInputs */

const vi_online_price_title = /** @type {(inputs: Online_Price_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bảng giá Online`)
};

/**

* @param {Online_Price_TitleInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const online_price_title = /** @type {((inputs?: Online_Price_TitleInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Online_Price_TitleInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_online_price_title(inputs)
});